import css from './NoQuery.module.css'

import { Config } from '#/global/helper/Config'

const i18n = {
    cz: {
        title: 'Nezadali jste hledaný výraz.',
    },
    sk: {
        title: 'Nezadali ste hľadaný výraz.',
    },
}

export const NoQuery = () => {
    const t = i18n[Config.getLang()]

    return (
        <div className="container">
            <div className={css.title}>{t.title}</div>
        </div>
    )
}
